class BasicHeader extends HTMLElement {
  constructor() {
    super();
  }

  get headerSection() {
    return document.querySelector('.header-section');
  }

  get enableTransparent() {
    return this.dataset.enableTransparent === 'true';
  }

  connectedCallback() {
    this.init();

    if (window.ResizeObserver) {
      new ResizeObserver(this.setHeight.bind(this)).observe(this);
    }

    if (Shopify.designMode) {
      const section = this.closest('.shopify-section');

      section.addEventListener(
        'shopify:section:load',
        this.init.bind(this)
      );

      section.addEventListener(
        'shopify:section:unload',
        this.init.bind(this)
      );

      section.addEventListener(
        'shopify:section:reorder',
        this.init.bind(this)
      );
    }
  }

  init() {
    new FoxTheme.delayUntilInteraction(
      this.setHeight.bind(this)
    );

    if (this.enableTransparent) {
      this.headerSection.classList.add(
        'header-transparent'
      );
    }
  }

  setHeight() {
    requestAnimationFrame(() => {
      const offsetHeight = Math.round(
        this.offsetHeight
      );

      const offsetTop = Math.round(
        this.parentElement.offsetTop
      );

      document.documentElement.style.setProperty(
        '--header-height',
        `${offsetHeight}px`
      );

      document.documentElement.style.setProperty(
        '--header-offset-top',
        `${offsetTop}px`
      );
    });
  }
}

customElements.define(
  'basic-header',
  BasicHeader,
  { extends: 'header' }
);



/* =========================================================
   STICKY HEADER
========================================================= */

class StickyHeader extends BasicHeader {
  constructor() {
    super();

    this.classes = {
      pinned: 'header-pinned',
    };
  }

  get isAlwaysSticky() {
    return this.dataset.stickyType === 'always';
  }

  connectedCallback() {
    super.connectedCallback();

    this.currentScrollTop = 0;
    this.firstScrollTop = window.scrollY;

    this.headerBounds =
      this.headerSection.getBoundingClientRect();

    this.beforeInit();
  }

  beforeInit() {
    this.headerSection.classList.add(
      'header-sticky'
    );

    this.headerSection.dataset.stickyType =
      this.dataset.stickyType;

    window.addEventListener(
      'scroll',
      this.onScrollHandler.bind(this),
      false
    );
  }

  onScrollHandler() {
    const scrollTop = window.scrollY;

    const headerSection =
      this.headerSection;

    const headerBoundsTop =
      this.headerBounds.top +
      this.firstScrollTop;

    const headerBoundsBottom =
      this.headerBounds.bottom +
      this.firstScrollTop;

    requestAnimationFrame(() => {

      if (scrollTop > headerBoundsTop) {

        headerSection.classList.add(
          'header-scrolled'
        );

        if (this.isAlwaysSticky) {

          document.body.classList.add(
            this.classes.pinned
          );

        } else {

          if (
            scrollTop < this.currentScrollTop ||
            scrollTop <
              headerBoundsBottom + 100
          ) {

            document.body.classList.add(
              this.classes.pinned
            );

          } else {

            document.body.classList.remove(
              this.classes.pinned
            );

          }
        }

      } else {

        headerSection.classList.remove(
          'header-scrolled'
        );

        document.body.classList.remove(
          this.classes.pinned
        );
      }

      this.currentScrollTop =
        scrollTop;
    });
  }
}

customElements.define(
  'sticky-header',
  StickyHeader,
  { extends: 'header' }
);



/* =========================================================
   DROPDOWN
   Desktop Dropdowns öffnen SOFORT
========================================================= */

const clearDropdownCount =
  new WeakMap();

class DetailsDropdown
  extends HTMLDetailsElement {

  constructor() {
    super();

    this.classes = {
      bodyClass: 'has-dropdown-menu'
    };

    this.events = {
      handleAfterHide:
        'menu:handleAfterHide',

      handleAfterShow:
        'menu:handleAfterShow',
    };


    this.summaryElement =
      this.firstElementChild;

    this.contentElement =
      this.lastElementChild;


    this._open =
      this.hasAttribute('open');


    this.summaryElement.addEventListener(
      'click',
      this.handleSummaryClick.bind(this)
    );


    if (this.trigger === 'hover') {

      this.summaryElement.addEventListener(
        'focusin',
        (event) => {

          if (
            event.target ===
            this.summaryElement
          ) {

            this.open = true;

          }
        }
      );


      this.summaryElement.addEventListener(
        'focusout',
        (event) => {

          if (
            !this.contentElement.contains(
              event.relatedTarget
            )
          ) {

            this.open = false;

          }
        }
      );
    }


    this.handleOutsideClick =
      this.handleOutsideClick.bind(this);

    this.handleEscKeyPress =
      this.handleEscKeyPress.bind(this);

    this.handleFocusOut =
      this.handleFocusOut.bind(this);


    this.hoverTimer = null;

    this.detectHoverListener =
      this.detectHover.bind(this);


    this.addEventListener(
      'mouseenter',
      this.detectHoverListener
    );

    this.addEventListener(
      'mouseleave',
      this.detectHoverListener
    );
  }



  set open(value) {

    if (value !== this._open) {

      this._open = value;


      if (this.isConnected) {

        this.transition(value);

      } else {

        if (value) {

          this.setAttribute(
            'open',
            ''
          );

        } else {

          this.removeAttribute(
            'open'
          );

        }
      }
    }
  }



  get open() {
    return this._open;
  }



  get trigger() {

    if (
      FoxTheme.config.isTouch
    ) {

      return 'click';

    }

    return (
      this.getAttribute(
        'trigger'
      ) || 'click'
    );
  }



  get level() {

    if (
      this.hasAttribute(
        'level'
      )
    ) {

      return this.getAttribute(
        'level'
      );

    }

    return 'top';
  }



  handleSummaryClick(event) {

    event.preventDefault();


    if (
      !FoxTheme.config.isTouch &&
      this.trigger === 'hover' &&
      this.summaryElement.hasAttribute(
        'data-link'
      )
    ) {

      window.location.href =
        this.summaryElement.getAttribute(
          'data-link'
        );

    } else {

      this.open =
        !this.open;

    }
  }



  async transition(value) {

    /* ===============================
       ÖFFNEN
    =============================== */

    if (value) {

      clearDropdownCount.set(
        DetailsDropdown,
        clearDropdownCount.get(
          DetailsDropdown
        ) + 1
      );


      document.body.classList.add(
        this.classes.bodyClass
      );


      /*
       * WICHTIG:
       * Früher war hier:
       *
       * setTimeout(..., 100)
       *
       * Der Inhalt wird jetzt
       * SOFORT geöffnet.
       */

      this.setAttribute(
        'open',
        ''
      );

      this.summaryElement.setAttribute(
        'open',
        ''
      );

      this.contentElement.setAttribute(
        'open',
        ''
      );


      document.addEventListener(
        'click',
        this.handleOutsideClick
      );

      document.addEventListener(
        'keydown',
        this.handleEscKeyPress
      );

      document.addEventListener(
        'focusout',
        this.handleFocusOut
      );


      await this.showWithTransition();


      this.needsReverse();


      return FoxTheme.utils.waitForEvent(
        this,
        this.events.handleAfterShow
      );


    /* ===============================
       SCHLIESSEN
    =============================== */

    } else {

      clearDropdownCount.set(
        DetailsDropdown,
        Math.max(
          0,
          clearDropdownCount.get(
            DetailsDropdown
          ) - 1
        )
      );


      document.body.classList.toggle(
        this.classes.bodyClass,
        clearDropdownCount.get(
          DetailsDropdown
        ) > 0
      );


      this.summaryElement.removeAttribute(
        'open'
      );

      this.contentElement.removeAttribute(
        'open'
      );


      document.removeEventListener(
        'click',
        this.handleOutsideClick
      );

      document.removeEventListener(
        'keydown',
        this.handleEscKeyPress
      );

      document.removeEventListener(
        'focusout',
        this.handleFocusOut
      );


      await this.hideWithTransition();


      if (!this.open) {

        this.removeAttribute(
          'open'
        );

      }


      return FoxTheme.utils.waitForEvent(
        this,
        this.events.handleAfterHide
      );
    }
  }



  /* =====================================================
     DROPDOWN SOFORT EINBLENDEN
  ===================================================== */

  async showWithTransition() {

    /*
     * Wir behalten FoxTheme.Motion bei,
     * setzen aber Duration + Delay auf 0.
     *
     * Dadurch bleibt die interne
     * Theme-Logik kompatibel.
     */

    FoxTheme.Motion.animate(
      this.contentElement,

      {
        opacity: [1, 1],
        visibility: 'visible'
      },

      {
        duration: 0,
        delay: 0
      }
    );


    if (
      this.contentElement
        .firstElementChild
    ) {

      return FoxTheme.Motion.animate(

        this.contentElement
          .firstElementChild,

        {
          transform: [
            'translateY(0)',
            'translateY(0)'
          ]
        },

        {
          duration: 0,
          delay: 0
        }

      ).finished;
    }


    return Promise.resolve();
  }



  /* =====================================================
     DROPDOWN SOFORT AUSBLENDEN
  ===================================================== */

  async hideWithTransition() {

    FoxTheme.Motion.animate(
      this.contentElement,

      {
        opacity: 0,
        visibility: 'hidden'
      },

      {
        duration: 0,
        delay: 0
      }
    );


    if (
      this.contentElement
        .firstElementChild
    ) {

      return FoxTheme.Motion.animate(

        this.contentElement
          .firstElementChild,

        {
          transform:
            'translateY(0)'
        },

        {
          duration: 0,
          delay: 0
        }

      ).finished;
    }


    return Promise.resolve();
  }



  handleOutsideClick(event) {

    const isClickInside =
      this.contains(
        event.target
      );


    const isClickOnDetailsDropdown =
      event.target.closest(
        'details'
      ) instanceof DetailsDropdown;


    if (
      !isClickInside &&
      !isClickOnDetailsDropdown
    ) {

      this.open = false;

    }
  }



  handleEscKeyPress(event) {

    if (
      event.code === 'Escape'
    ) {

      const targetMenu =
        event.target.closest(
          'details[open]'
        );


      if (targetMenu) {

        targetMenu.open =
          false;

      }
    }
  }



  handleFocusOut(event) {

    if (
      event.relatedTarget &&
      !this.contains(
        event.relatedTarget
      )
    ) {

      this.open = false;

    }
  }



  handleHoverOpen() {
    this.open = true;
  }



  handleHoverClose() {
    this.open = false;
  }



  detectHover(event) {

    if (
      this.trigger === 'hover'
    ) {

      /*
       * KEIN Debounce
       * KEIN Timeout
       *
       * Maus rein  -> sofort auf
       * Maus raus  -> sofort zu
       */

      this.open =
        event.type ===
        'mouseenter';

    }
  }



  needsReverse() {

    const totalWidth =
      this.contentElement.offsetLeft +
      this.contentElement.clientWidth *
        2;


    if (
      totalWidth >
      window.innerWidth
    ) {

      this.contentElement.classList.add(
        'needs-reverse'
      );

    }
  }
}



customElements.define(
  'details-dropdown',
  DetailsDropdown,
  { extends: 'details' }
);


clearDropdownCount.set(
  DetailsDropdown,
  0
);



/* =========================================================
   MEGA MENU
   Ebenfalls SOFORT öffnen
========================================================= */

class DetailsMega
  extends DetailsDropdown {

  constructor() {

    super();


    if (
      Shopify.designMode
    ) {

      this.addEventListener(
        'shopify:block:select',
        () => {

          this.open = true;

        }
      );


      this.addEventListener(
        'shopify:block:deselect',
        () => {

          this.open = false;

        }
      );
    }
  }



  /* Mega Menu SOFORT sichtbar */

  async showWithTransition() {

    const element =
      this.contentElement
        .firstElementChild;


    if (!element) {

      return Promise.resolve();

    }


    return FoxTheme.Motion.animate(

      element,

      {
        visibility: 'visible',
        opacity: [1, 1],

        transform: [
          'translateY(0)',
          'translateY(0)'
        ]
      },

      {
        duration: 0,
        delay: 0
      }

    ).finished;
  }



  /* Mega Menu SOFORT schließen */

  async hideWithTransition() {

    const element =
      this.contentElement
        .firstElementChild;


    if (!element) {

      return Promise.resolve();

    }


    return FoxTheme.Motion.animate(

      element,

      {
        visibility: 'hidden',

        transform:
          'translateY(0)'
      },

      {
        duration: 0,
        delay: 0
      }

    ).finished;
  }
}



customElements.define(
  'details-mega',
  DetailsMega,
  { extends: 'details' }
);



/* =========================================================
   MOBILE MENU DRAWER
   Original Sleek Animation bleibt erhalten
========================================================= */

class MenuDrawerDetails
  extends HTMLDetailsElement {

  constructor() {

    super();


    this.summary.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );


    this.closeButton.addEventListener(
      'click',
      this.onCloseButtonClick.bind(this)
    );
  }



  get parent() {

    return this.closest(
      '[data-parent]'
    );
  }



  get summary() {

    return this.querySelector(
      'summary'
    );
  }



  get closeButton() {

    return this.querySelector(
      'button'
    );
  }



  onSummaryClick() {

    setTimeout(() => {

      this.parent.classList.add(
        'active'
      );

      this.classList.add(
        'active'
      );

      this.summary.setAttribute(
        'aria-expanded',
        true
      );

    }, 100);
  }



  onCloseButtonClick() {

    this.parent.classList.remove(
      'active'
    );

    this.classList.remove(
      'active'
    );

    this.summary.setAttribute(
      'aria-expanded',
      false
    );


    this.closeAnimation();
  }



  closeAnimation() {

    let animationStart;


    const handleAnimation =
      (time) => {

        if (
          animationStart ===
          undefined
        ) {

          animationStart =
            time;

        }


        const elapsedTime =
          time -
          animationStart;


        if (
          elapsedTime < 400
        ) {

          window.requestAnimationFrame(
            handleAnimation
          );

        } else {

          this.removeAttribute(
            'open'
          );

        }
      };


    window.requestAnimationFrame(
      handleAnimation
    );
  }
}



customElements.define(
  'menu-drawer-details',
  MenuDrawerDetails,
  { extends: 'details' }
);



/* =========================================================
   MOBILE DRAWER
========================================================= */

class MenuDrawer
  extends DrawerComponent {

  constructor() {

    super();

  }



  get menuItems() {

    if (!this._menuItems) {

      this._menuItems =
        this.querySelectorAll(
          '.menu-drawer__menus:not(.active) > li'
        );

    }


    return this._menuItems;
  }



  prepareToShow() {

    super.prepareToShow();


    setTimeout(() => {

      this.animateMenuItems();

    }, 300);
  }



  animateMenuItems() {

    FoxTheme.Motion.animate(

      this.menuItems,

      {
        transform: [
          'translateX(-20px)',
          'translateX(0)'
        ],

        opacity: [0, 1],
      },

      {
        duration: 0.6,

        easing: [
          0.075,
          0.82,
          0.165,
          1
        ],

        delay:
          FoxTheme.Motion.stagger(
            0.1
          ),
      }

    ).finished.then(() => {

      this.menuItems.forEach(
        (item) =>
          item.removeAttribute(
            'style'
          )
      );

    });
  }



  handleAfterHide() {

    super.handleAfterHide();


    setTimeout(() => {

      this.querySelectorAll(
        'details[is=menu-drawer-details]'
      ).forEach(
        (menu) => {

          menu.onCloseButtonClick();

        }
      );

    });
  }
}



customElements.define(
  'menu-drawer',
  MenuDrawer
);



/* =========================================================
   PRODUCT LIST IM MEGA MENU
========================================================= */

class MenuProductList
  extends HTMLElement {

  constructor() {

    super();

    this.initSlide();

    this.elementToFocus =
      this.querySelector(
        'button'
      );
  }



  get container() {

    return this.querySelector(
      '.swiper'
    );
  }



  get sliderPagination() {

    return this.querySelector(
      '.swiper-pagination'
    );
  }



  get sliderNext() {

    return this.querySelector(
      '.swiper-button-next'
    );
  }



  get sliderPrev() {

    return this.querySelector(
      '.swiper-button-prev'
    );
  }



  get numberOfColumns() {

    return parseInt(
      this.dataset.columns
    );
  }



  initSlide() {

    const slider =
      new FoxTheme.Carousel(
        this.container,
        {

          spaceBetween: 10,

          slidesPerView:
            this.numberOfColumns,

          loop: false,


          pagination: {

            el:
              this.sliderPagination,

            type:
              'fraction',

          },


          navigation: {

            nextEl:
              this.sliderNext,

            prevEl:
              this.sliderPrev,

          },


          focusableElements:
            'input, select, option, textarea, button, video, label',

        }
      );


    slider.init();


    const focusableElements =
      FoxTheme.a11y
        .getFocusableElements(
          this
        );


    focusableElements.forEach(
      (element) => {

        element.addEventListener(
          'focusin',
          function () {

            const slide =
              element.closest(
                '.swiper-slide'
              );


            slide &&
              slider.slider.slideTo(
                slider.slider.slides.indexOf(
                  slide
                )
              );

          }
        );

      }
    );
  }
}



customElements.define(
  'menu-product-list',
  MenuProductList
);